// ***************************************
// Definition of game token MomentPlayer
// ***************************************
import { tbAnimator } from "../engine/tbAnimator";
import { tbGame } from "../engine/tbGame";
// The constructor for the MomentPlayer game token. 
export var MomentPlayer = function (onEvent, context) {
    "use strict";
    // Properties used by the engine
    this.layer = 0;
    this.visible = true;
    this.active = true;
    // Your own properties
    this._onEvent = onEvent;
    this._context = context;
    this._animator = new tbAnimator(context);
    // Add it to the game engine
    tbGame.addToken(this);
};
// handleRemove is called when the token is removed from the game.
MomentPlayer.prototype.handleRemove = function () {
    "use strict";
};
MomentPlayer.prototype.addEvent = function (time, obj) {
    "use strict";
    this._animator.addEvent(this._context, time, this._onEvent, obj);
};
// handleBeginStep is called each step before processing other events.
MomentPlayer.prototype.handleBeginStep = function (timePassed) {
    "use strict";
    this._animator.updateTime(timePassed);
    if (this._animator.currentTime >= this._animator.duration) {
        this._animator.removeEvents();
        tbGame.removeToken(this);
    }
};
